import React from 'react';
import { ButtonBase, Typography, useTheme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import { formatCurrency } from '../../../shared/utils/currency';

export interface PaymentGroupHeaderProps {
  groupName: string;
  isGang: boolean;
  count: number;
  totalAmount: number;
  expanded: boolean;
  onToggle: () => void;
  'data-testid'?: string;
  panelId?: string;
}

export const PaymentGroupHeader = React.memo(function PaymentGroupHeader({
  groupName,
  isGang,
  count,
  totalAmount,
  expanded,
  onToggle,
  'data-testid': dataTestId,
  panelId,
}: PaymentGroupHeaderProps) {
  const theme = useTheme();
  const GroupIcon = isGang ? GroupsIcon : PersonIcon;

  return (
    <ButtonBase
      onClick={onToggle}
      data-testid={dataTestId}
      aria-expanded={expanded}
      aria-controls={panelId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        px: { xs: 2, sm: 3 },
        py: 1,
        justifyContent: 'flex-start',
        bgcolor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.03)'
            : 'rgba(0, 0, 0, 0.02)',
        '&:hover': {
          bgcolor:
            theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.06)'
              : 'rgba(0, 0, 0, 0.04)',
        },
      }}
    >
      <ChevronRightIcon
        fontSize="small"
        sx={{
          color: 'text.secondary',
          transition: 'transform 150ms ease',
          transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
        }}
      />
      <GroupIcon
        sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }}
      />
      <Typography variant="body2" fontWeight={600}>
        {groupName}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {count}
      </Typography>
      <Typography variant="body2" fontWeight={600} sx={{ ml: 'auto' }}>
        {formatCurrency(totalAmount)}
      </Typography>
    </ButtonBase>
  );
});
